import type { FaireProductEntity } from "../../entity_types/product";

export const p_4yrfvdanaw: FaireProductEntity = {
  token: "p_4yrfvdanaw",
  type: "product",
  name: "18K Gold Plated Waterproof Stainless Steel Chain Necklace - 7245",
  brandToken: "b_4zc36e4kj9",
  brandName: "Mia Accessories",
  imageUrl:
    "https://cdn.faire.com/fastly/a5564cf0671422dbca7b42de45f622c945351915ad976afb9fef202a2ea028fd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a236001e1daf5f037bd67d345ce85c593dabd2b749c33342ba2838deb9887084.jpeg",
    "https://cdn.faire.com/fastly/c61927364681033930ed9b26c5c7a1c15c5231168015ba118c234c41b67fe7e2.jpeg",
  ],
  priceDollars: 8.52,
  description:
    '18K Gold Plated Beaded Stainless Steel Necklace.\n15.5"L + 2" extender.\n\n\n\n\nThis item is hypoallergenic, waterproof and tarnish-resistant.\n\n*To prolong the shine and finish of the gold plating, contact with chemicals such as lotions, perfumes, and cleaning products should be avoided.*\n\n\n\nDainty Chain Necklace | Beaded Chain Necklace | Multicolored Crystal Necklace | Glass Crystal Beaded Necklace | Real Gold Dipped Necklace | Real Gold Plated Necklace | Waterproof & Sweatproof Necklace | Layering Necklace | Simple Delicate Gold Necklace | Spring Summer Necklace\n',
  tags: [],
  msrpDollars: 34.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:09.533Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
